import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Cleave from 'cleave.js'
import { ValidationProvider, ValidationObserver, extend, setInteractionMode } from 'vee-validate'
// eslint-disable-next-line camelcase
import { required, min, alpha_spaces, max } from 'vee-validate/dist/rules.umd'

import '@/assets/css/tailwind.css'

Vue.directive('cleave', {
  inserted: (el, binding) => {
    el.cleave = new Cleave(el, binding.value || {})
  },
  update: (el) => {
    const event = new Event('input', { bubbles: true })
    setTimeout(function () {
      el.value = el.cleave.properties.result
      el.dispatchEvent(event)
    }, 100)
  }
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

extend('required', {
  ...required,
  message: 'Required'
})
extend('min', {
  ...min,
  message: '{_field_} is incomplete'
})
extend('alpha_spaces', {
  // eslint-disable-next-line camelcase
  ...alpha_spaces,
  message: 'May only contain alphabetic characters'
})
extend('max', {
  ...max,
  message: 'Maximum character reached'
})
extend('card_date', {
  validate (value) {
    const date = value.split(' /')
    const month = parseInt(date[0].trim())
    const year = parseInt(date[1].trim())
    const today = new Date() // gets the current date
    let todayMonth = today.getMonth() + 1 // extracts the month portion
    const todayYear = today.getFullYear() % 100 // extracts the year portion and changes it from yyyy to yy format
    if (todayMonth < 10) { // if today's month is less than 10
      todayMonth = '0' + todayMonth // prefix it with a '0' to make it 2 digits
    }
    return year > todayYear || (year === todayYear && month >= todayMonth)
  },
  message: 'Date must be in the future'
})
setInteractionMode('passive')

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
